(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["st-product-system"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', (event) => {
  const link = event.target.closest('[data-st-thumb]');
  if (!link) return;
  const root = link.closest('[data-st-product]');
  const target = root.querySelector(link.getAttribute('href'));
  const gallery = root.querySelector('.stp-gallery');
  if (!target || !gallery) return;
  event.preventDefault();
  gallery.scrollTo({left:target.offsetLeft - gallery.querySelector('figure').offsetLeft,behavior:window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth'});
  root.querySelectorAll('[data-st-thumb]').forEach(item => item.removeAttribute('aria-current'));
  link.setAttribute('aria-current','true');
});
document.addEventListener('change', (event) => {
  if (!event.target.matches('[data-st-variant]')) return;
  const url = new URL(window.location.href);
  url.searchParams.set('variant', event.target.value);
  window.location.assign(url.toString());
});

  } catch(e) { console.error(e); }
})();
})();
